import * as Styled from './AvatarGroup.styles';

const AvatarGroup = ({ children }) => {
  return <Styled.AvatarGroup>{children}</Styled.AvatarGroup>;
};

export default AvatarGroup;
